import LBox from "../mobile/utils/levenshtein-toolbox";
import _ from "lodash";
import { decode, encode } from "html-entities";
import htmlparser2 from "htmlparser2-without-node-native";
import DomHandler from "domhandler";
import { v4 as uuid } from "uuid";
class Handler extends DomHandler {
    constructor() {
        super({ withStartIndices: true, withEndIndices: true });
    }

    // It appears that htmlparser2 doesn't correctly process
    // ProcessingInstructions. Their "endIndex" isn't set properly.
    onprocessinginstruction(name, data) {
        this.parser.endIndex = this.parser.tokenizer._index;
        super.onprocessinginstruction(name, data);
    }
}

const MergeLBNodes = (nodes) => {
    //merge nodes
    let result = [];
    let lastNode = null;
    for (let i = 0; i < nodes.length; ++i) {
        const node = nodes[i];
        const text = getNodeLetters(node);
        if (text === "\n") {
            if (lastNode) {
                result.push(lastNode);
                lastNode = null;
            }
            result.push(node);
            continue;
        }

        if (lastNode) {
            if (lastNode.op === node.op) {
                switch (node.op) {
                    // match operation was done
                    case "M":
                        lastNode.letter += node.letter;
                        lastNode.from += node.from;
                        lastNode.to += node.to;
                        break;
                    // subtitution operation was done
                    case "S":
                        lastNode.from += node.from;
                        lastNode.to += node.to;
                        break;
                    // insert operation was done
                    case "I":
                        lastNode.letter += node.letter;
                        lastNode.to += node.to;
                        break;
                    // delete operation was done
                    case "D":
                        lastNode.letter += node.letter;
                        lastNode.from += node.from;
                        break;
                    default:
                        break;
                }
            } else {
                result.push(lastNode);
                lastNode = _.cloneDeep(node);
            }
        } else {
            lastNode = _.cloneDeep(node);
        }
    }

    if (lastNode) {
        result.push(lastNode);
    }

    return result;
};

/**
 * HtmlNode
 */
class HtmlNode {
    /**
     * @constructor
     * @param child
     * @param parentNode
     * @param index
     */
    constructor(child, parentNode, index) {
        this.textStartIndex = 0;
        this.textEndIndex = 0;
        this.node = child;
        this.subIndex = index;
        this.LBNode = [];
        this.subHtmlNodes = [];
        if (child.type === "tag") {
            this.text = "";
            this.startIndex = child.startIndex;
            this.endIndex = child.endIndex;
            this.tag = child.name;
            this.isSubTag = parentNode !== null;
            this.parentNode = child.parentNode;
            this.isText = false;
            this.subHtmlNodes = _.map(child.children, (subNode, index) => {
                return new HtmlNode(subNode, child, index);
            });
        } else if (child.type === "text") {
            this.text = child.data;
            this.startIndex = child.startIndex;
            this.endIndex = child.endIndex;
            this.tag = "";
            this.isText = true;
            this.isSubTag = parentNode !== null;
            this.parentNode = child.parentNode;
        }
    }

    get RawText() {
        return this.isText
            ? this.text
            : _.join(
                  _.map(this.subHtmlNodes, (s) => s.Text),
                  ""
              );
    }

    get Text() {
        return decode(this.RawText);
    }

    get TextForRender() {
        return encode(this.RawText);
    }

    processInnerLBNodes(node) {
        const startIndex = node.i;
        const endIndex = node.i + (node.from ? node.from.length : 0);
        const targetHtmlNode = _.find(this.subHtmlNodes, (s) => s.textStartIndex <= startIndex && s.textEndIndex >= endIndex);
        if (targetHtmlNode) {
            targetHtmlNode.LBNode.push(_.cloneDeep(node));
            targetHtmlNode.processInnerLBNodes(_.cloneDeep(node));
        }
    }

    mergeLBNodes() {
        if (this.subHtmlNodes.length === 0) {
            const backupNodes = _.cloneDeep(this.LBNode);
            this.backupNodes = backupNodes;
            this.LBNode = MergeLBNodes(this.LBNode);
        } else {
            for (let i = 0; i < this.subHtmlNodes.length; i++) {
                const node = this.subHtmlNodes[i];
                node.mergeLBNodes();
            }
        }
    }

    processInnerSubNodes() {
        for (let i = 0; i < this.subHtmlNodes.length; i++) {
            const lastNode = i > 0 ? this.subHtmlNodes[i - 1] : null;
            const node = this.subHtmlNodes[i];
            const startIndex = node.subIndex === 0 ? this.textStartIndex : lastNode.textEndIndex;
            node.textStartIndex = startIndex;
            node.textEndIndex = startIndex + node.Text.length;
            node.processInnerSubNodes();
        }
    }

    renderCorrectedHtml() {
        if (this.isText) {
            return this.Text;
        } else {
            let attrStr = "";
            let classes = "";
            if (this.node.attributes) {
                for (const attr of this.node.attributes) {
                    attrStr += `${attr.name}='${attr.value}'`;
                    if (attr.name === "class") {
                        classes = attr.value;
                    }
                }
            }

            //ignore the correction of del
            if (this.tag === "span") {
                if (classes.indexOf("aic-ins") > -1) {
                    return this.Text;
                } else if (classes.indexOf("aic-del") > -1) {
                    return "";
                }
            }

            //ignore comment
            if (classes.indexOf("aic-comment-sentence-icon") > -1) {
                return "";
            } else if (classes.indexOf("aic-comment-sentence-popover") > -1) {
                return "";
            }

            if (classes.indexOf("aic-comment-sentence") > -1) {
                return _.join(
                    _.map(this.subHtmlNodes, (s) => s.renderCorrectedHtml()),
                    ""
                );
            }

            //ignore comment
            if (classes.indexOf("aic-comment-paragraph") > -1) {
                return "";
            }

            return `<${this.tag} ${attrStr} >${_.join(
                _.map(this.subHtmlNodes, (s) => s.renderCorrectedHtml()),
                ""
            )}</${this.tag}>`;
        }
    }

    filterCommentClass = (classes) => {
        if (classes && classes.length > 0){
            const classArr = classes.split(" ");
            const filteredArr = _.filter(classArr, s=> s.indexOf("aic-comment-sentence") <= -1);
            return _.join(filteredArr, " ");
        }

        return "";
    }

    renderOriginalHtml() {
        if (this.isText) {
            return this.Text;
        } else {
            let attrStr = "";
            let classes = "";
            if (this.node.attributes) {
                for (const attr of this.node.attributes) {
                    if (attr.name === "class") {
                        classes = attr.value;
                        attrStr += `${attr.name}='${this.filterCommentClass(attr.value)}'`;
                    } else {
                        attrStr += `${attr.name}='${attr.value}'`;
                    }
                }
            }

            //ignore the correction of del
            if (this.tag === "span") {
                if (classes.indexOf("aic-ins") > -1) {
                    return "";
                } else if (classes.indexOf("aic-del") > -1) {
                    return this.Text;
                }
            }

            //ignore comment
            if (classes.indexOf("aic-comment-sentence-icon") > -1) {
                return "";
            } else if (classes.indexOf("aic-comment-sentence-popover") > -1) {
                return "";
            }

            if (classes.indexOf("aic-comment-sentence") > -1) {
                return _.join(
                    _.map(this.subHtmlNodes, (s) => s.renderOriginalHtml()),
                    ""
                );
            }

            //ignore comment
            if (classes.indexOf("aic-comment-paragraph") > -1) {
                return "";
            }

            return `<${this.tag} ${attrStr} >${_.join(
                _.map(this.subHtmlNodes, (s) => s.renderOriginalHtml()),
                ""
            )}</${this.tag}>`;
        }
    }

    renderHtml() {
        if (this.isText) {
            if (this.LBNode.length > 0) {
                return _.join(
                    _.map(this.LBNode, (item, index) => {
                        const renderActionHTML = (node, i, exstyle = "") => {
                            switch (node.op) {
                                // match operation was done
                                case "M":
                                    return encode(node.letter);
                                // subtitution operation was done
                                case "S":
                                    if (_.isEmpty(node.to.trim())) {
                                        return encode(node.to);
                                    }
                                    return `<span class="aic-del cts-1" data-cid="${uuid()}" data-userid="aic" data-username="aic" data-time="${new Date().getTime()}" style='${exstyle}'>${
                                        node.from
                                    }</span><span class="aic-ins cts-1" data-cid="${uuid()}" data-userid="aic" data-username="aic" data-time="${new Date().getTime()}"  style='${exstyle}'>${
                                        node.to
                                    }</span>`;
                                // insert operation was done
                                case "I":
                                    if (_.isEmpty(node.letter.trim())) {
                                        return encode(node.letter);
                                    }
                                    return `<span class="aic-ins cts-1" data-cid="${uuid()}" data-userid="aic" data-username="aic" data-time="${new Date().getTime()}"  style='${exstyle}'>${
                                        node.letter
                                    }</span>`;
                                // delete operation was done
                                case "D":
                                    if (_.isEmpty(node.letter.trim())) {
                                        return encode(node.letter);
                                    }
                                    return `<span  class="aic-del cts-1" data-cid="${uuid()}" data-userid="aic" data-username="aic" data-time="${new Date().getTime()}"   style='${exstyle} '>${
                                        node.letter
                                    }</span>`;
                                default:
                                    break;
                            }
                            return "";
                        };

                        return renderActionHTML(item, index, "");
                    }),
                    ""
                );
            } else {
                return this.Text;
            }
        } else {
            let attrStr = "";
            if (this.node.attributes) {
                for (const attr of this.node.attributes) {
                    attrStr += `${attr.name}='${attr.value}'`;
                }
            }

            return `<${this.tag} ${attrStr} >${_.join(
                _.map(this.subHtmlNodes, (s) => s.renderHtml()),
                ""
            )}</${this.tag}>`;
        }
    }
}

/**
 * just check the p span tag is ok
 * @param p
 */
const isHtml = (p) => {
    return /<(div|em|p|small|span|strike|strong|style).*?<\/\1>/i.test(p);
};

/**
 * 全角字符转换为半角字符
 * @param str
 * @returns {string}
 */
function ToCDB(str) {
    let tmp = "";
    for (let i = 0; i < str.length; i++) {
        if (str.charCodeAt(i) > 65248 && str.charCodeAt(i) < 65375) {
            tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
        } else {
            tmp += String.fromCharCode(str.charCodeAt(i));
        }
    }
    return tmp;
}

function isSamePunctuation(a, b) {
    return ToCDB(a) === ToCDB(b);
}

const getNodeLetters = (node) => {
    switch (node.op) {
        // match operation was done
        case "M":
            return node.letter;
        // subtitution operation was done
        case "S":
            return node.to;
        // insert operation was done
        case "I":
            return node.letter;
        // delete operation was done
        case "D":
            return node.letter;
        default:
            return "";
    }
};

const getNodesText = (nodes) => {
    let result = "";
    for (let i = 0; i < nodes.length; ++i) {
        result += getNodeLetters(nodes[i]);
    }
    return result;
};

const splitNodes = (nodes) => {
    const result = [];
    let curParagraph = null;
    for (let i = 0; i < nodes.length; ++i) {
        nodes[i].index = i;
        const t = getNodeLetters(nodes[i]);
        if (t === "\n") {
            if (curParagraph) {
                result.push(curParagraph);
                curParagraph = null;
            }
        } else {
            if (!curParagraph) {
                curParagraph = [];
            }
            curParagraph.push(nodes[i]);
        }
    }

    if (curParagraph) {
        result.push(curParagraph);
    }
    return result;
};

// the `matchCost` function dictates the cost when both
// letters in both strings match, and if they don't match,
// the cost of doing a substitution from the first to the second.
// you can even vary the cost depending on the letters being compared.
const matchCost = (c1, c2, i, j, refArray) => {
    return isSamePunctuation(c1, c2) ? 0 : 1;
};

const matchType = (c1, c2, i, j) => {
    if (matchCost(c1, c2, i, j) === 0) {
        return "M";
    } else {
        return "S";
    }
};

const buildInternalLBoxPath = (data, merge = true) => {
    if (!data) {
        return [];
    }
    const l = new LBox({ caseSensitive: true });
    //文字不同,拼音相同,也认为是同一字
    l.set("matchCost", (c1, c2, i, j) => matchCost(c1, c2, i, j));
    l.set("_matchType", (c1, c2, i, j) => matchType(c1, c2, i, j));

    // perform the Levenshtein distance algorithm,
    // converting `patternString` to `text`.
    l.process(data.answers, data.correction);
    const p = l.reconstructPath();
    if (!merge) {
        return p;
    }
    return MergeLBNodes(p);
};

const puncMap = {
    ".": true,
    ",": true,
    ";": true,
    "!": true,
    "?": true,
    "。": true,
    "，": true,
    "；": true,
    "！": true,
    "？": true,
};
const extractTitleAndParagraphForOrgComp = (text) => {
    let title = null;
    const paragraphs = text.split("\n");
    if (paragraphs.length > 0) {
        title = paragraphs[0];
        const texts = title;
        if (texts.length > 20) {
            title = null;
        } else {
            for (let i = texts.length - 1; i >= 0; --i) {
                if (puncMap[texts[i]]) {
                    title = null;
                    break;
                }
            }
        }

        if (title != null) {
            paragraphs.splice(0, 1);
        }
    }

    return {
        title,
        paragraphs,
    };
};

const extractTitleAndParagraph = (nodes) => {
    let title = null;
    const paragraphs = [...splitNodes(nodes)];
    if (paragraphs.length > 0) {
        title = paragraphs[0];
        const texts = getNodesText(title);
        if (texts.length > 20) {
            title = null;
        } else {
            for (let i = texts.length - 1; i >= 0; --i) {
                if (puncMap[texts[i]]) {
                    title = null;
                    break;
                }
            }
        }

        if (title != null) {
            paragraphs.splice(0, 1);
        }
    }

    return {
        title,
        paragraphs,
    };
};
const renderCorrectionHTMLForText = (nodes) => {
    const { title, paragraphs } = extractTitleAndParagraph(nodes);
    const renderActionHTML = (node, i, exstyle = "") => {
        switch (node.op) {
            // match operation was done
            case "M":
                return `<span  style= " ${exstyle} ">${node.letter}</span>`;
            // subtitution operation was done
            case "S":
                if (_.isEmpty(node.to.trim())) {
                    return "";
                }
                if (isSamePunctuation(node.to, node.from)) {
                    return "";
                }
                return `<span class="aic-del cts-1" data-cid="${uuid()}" data-userid="aic" data-username="aic" data-time="${new Date().getTime()}"  style='${exstyle}'>${
                    node.from
                }</span><span class="aic-ins cts-1" data-cid="${uuid()}" data-userid="aic" data-username="aic" data-time="${new Date().getTime()}"  style='${exstyle}'>${node.to}</span>`;
            // insert operation was done
            case "I":
                if (_.isEmpty(node.letter.trim())) {
                    return "";
                }
                return `<span class="aic-ins cts-1" data-cid="${uuid()}" data-userid="aic" data-username="aic" data-time="${new Date().getTime()}"  style='${exstyle}'>${node.letter}</span>`;
            // delete operation was done
            case "D":
                if (_.isEmpty(node.letter.trim())) {
                    return `<span  style='color: #000; ${exstyle} '>${node.letter}</span>`;
                }
                return `<span class="aic-del cts-1" data-cid="${uuid()}" data-userid="aic" data-username="aic" data-time="${new Date().getTime()}"   style='${exstyle} '>${node.letter}</span>`;
            default:
                break;
        }
        return "";
    };
    const renderTitleHTML = (p) => {
        return `<p style="text-align: center" >
                    <span style="line-height: 30px ">${_.join(
                        p.map((it, j) => renderActionHTML(it, j, "font-weight: bold")),
                        ""
                    )}</span>
                </p>`;
    };
    const renderParagraphHMTL = (p, i) => {
        return `<p >
                    <span style="line-height: 30px ;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${_.join(
                        p.map((it, j) => renderActionHTML(it, j)),
                        ""
                    )}</span>
                </p>`;
    };

    const titleHtml = title ? renderTitleHTML(title) : "";
    const otherHtml = _.join(
        paragraphs.map((p, i) => renderParagraphHMTL(p, i)),
        ""
    );

    return titleHtml + otherHtml;
};

const buildAnswerHtml = (realAnswer) => {
    try {
        // const userAnswerObj = JSON.parse(answer);
        // const { answers: realAnswer } = userAnswerObj;
        const { paragraphs, title } = extractTitleAndParagraphForOrgComp(realAnswer);
        const titleHtml = title ? `<p style="text-align: center">${title}</p>` : "";
        const otherHtml = _.join(
            paragraphs.map((p, i) => `<p style="margin-top: 10px"><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;${p}</span></p>`),
            ""
        );
        return titleHtml + otherHtml;
    } catch (e) {
        console.error(e);
        return "";
    }
};

function decodeHtml(html) {
    return decode(html);
}

function buildLBoxPathHtml(data, html) {
    const orgText = html;
    const textArr = [];
    let text = "";
    //解析html
    let handler = new Handler();
    const parser = new htmlparser2.Parser(handler, {
        xmlMode: false,
        lowerCaseAttributeNames: true,
        lowerCaseTags: true,
    });
    parser.end(orgText);

    _.each(handler.dom, (child, index) => {
        const htmlNode = new HtmlNode(child, null, index);
        htmlNode.textStartIndex = text.length;
        text += htmlNode.Text;
        htmlNode.textEndIndex = text.length;
        htmlNode.processInnerSubNodes();
        textArr.push(htmlNode);
    });

    const result = buildInternalLBoxPath(
        {
            answers: text,
            correction: data.correction,
        },
        false
    );

    for (let i = 0; i < result.length; i++) {
        const node = result[i];
        const startIndex = node.i;
        const endIndex = node.i + (node.from ? node.from.length : 0);
        const targetHtmlNode = _.find(textArr, (s) => s.textStartIndex <= startIndex && s.textEndIndex >= endIndex);
        if (targetHtmlNode) {
            targetHtmlNode.LBNode.push(_.cloneDeep(node));
            targetHtmlNode.processInnerLBNodes(_.cloneDeep(node));
        }
    }

    //merge nodes
    for (let i = 0; i < textArr.length; i++) {
        const node = textArr[i];
        node.mergeLBNodes();
    }
    return {
        isAnswerHTml: true,
        HtmlNode: textArr,
        LBoxNode: result,
    };
}

const buildLBoxPath = (data, html) => {
    let isAnswerHTml = false;
    if (html && html.length > 0) {
        isAnswerHTml = isHtml(html);
    }

    if (isAnswerHTml) {
        return buildLBoxPathHtml(data, html);
    } else {
        return buildInternalLBoxPath(data, true);
    }
};

const renderCorrectionHTML = (node) => {
    if (_.isPlainObject(node)) {
        const { HtmlNode, LBoxNode, isAnswerHTml } = node;
        return _.join(
            _.map(HtmlNode, (node) => {
                return node.renderHtml();
            }),
            ""
        );
    } else {
        return renderCorrectionHTMLForText(node);
    }
};

const isAnswerHTml = (answer) => {
    if (answer && answer.html && answer.html.length > 0) {
        return isHtml(answer.html);
    }

    return false;
};

const GetPlainHtmlAfterCorrection = (html) => {
    const textArr = [];
    let text = "";
    //解析html
    let handler = new Handler();
    const parser = new htmlparser2.Parser(handler, {
        xmlMode: false,
        lowerCaseAttributeNames: true,
        lowerCaseTags: true,
    });
    parser.end(html);

    _.each(handler.dom, (child, index) => {
        const htmlNode = new HtmlNode(child, null, index);
        htmlNode.textStartIndex = text.length;
        text += htmlNode.Text;
        htmlNode.textEndIndex = text.length;
        htmlNode.processInnerSubNodes();
        textArr.push(htmlNode);
    });

    return _.join(
        _.map(textArr, (node) => {
            return node.renderCorrectedHtml();
        }),
        ""
    );
};

const GetPlainHtmlIgnoreCorrection = (html) => {
    const textArr = [];
    let text = "";
    //解析html
    let handler = new Handler();
    const parser = new htmlparser2.Parser(handler, {
        xmlMode: false,
        lowerCaseAttributeNames: true,
        lowerCaseTags: true,
    });
    parser.end(html);

    _.each(handler.dom, (child, index) => {
        const htmlNode = new HtmlNode(child, null, index);
        htmlNode.textStartIndex = text.length;
        text += htmlNode.Text;
        htmlNode.textEndIndex = text.length;
        htmlNode.processInnerSubNodes();
        textArr.push(htmlNode);
    });

    return _.join(
        _.map(textArr, (node) => {
            return node.renderOriginalHtml();
        }),
        ""
    );
};

export {
    extractTitleAndParagraph,
    extractTitleAndParagraphForOrgComp,
    getNodeLetters,
    buildInternalLBoxPath,
    splitNodes,
    getNodesText,
    buildAnswerHtml,
    renderCorrectionHTML,
    decodeHtml,
    buildLBoxPath,
    isHtml,
    isAnswerHTml,
    GetPlainHtmlAfterCorrection,
    GetPlainHtmlIgnoreCorrection,
};
